import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import Autorenew from '@material-ui/icons/Autorenew'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const styles = theme => ({
  resetDefaultsButton: {
    marginTop: 4,
    marginRight: 6,
    float: 'right'
  },
  reset: {}
})

class ResetDefaultsButton extends React.PureComponent {
  constructor (props) {
    super(props)
    const { classes, resetDefaults } = this.props
    this.pure = {}
    this.pure.markup =
      <IconButton className={classes.resetDefaultsButton} aria-label="Reset to defaults" onClick={resetDefaults}>
        <Tooltip title="Reset to defaults" disableTouchListener={true} disableFocusListener={true}>
          <Autorenew />
        </Tooltip>
      </IconButton>
  }

  render () {
    return (this.pure.markup)
  }
}

ResetDefaultsButton.propTypes = {
  classes: PropTypes.object.isRequired,
  resetDefaults: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ResetDefaultsButton)
  )
)
